import {extend} from 'vee-validate';
import {email, max, regex, required} from 'vee-validate/dist/rules';

extend('required', {...required, message: field => 'Providing the ' + field.toLowerCase() + ' is required.'});
extend('email', {
	...email,
	message: 'This is not a valid email format. “example@grandpad.net” is an example of a proper format.'
});
extend('max', {...max, message: 'The {_field_} field cannot be longer than {length} characters.'});
extend('regex', regex);
extend('truthy', {
	validate: function (value)
	{
		return !!value;
	}
});

// This is a special rule that can be added dynamically that is always invalid
extend('invalid', {
	validate: function (value)
	{
		return false;
	}
});
